export default __webpack_public_path__ + "static/media/fontawesome-webfontd41d.8b43027f.eot";